import { useMemo } from 'react';
import { AGILE_ORG } from '../../../../../utils/constants';

interface GroupRole {
  id: string;
  role: string;
  displayRole?: string;
}

interface Group {
  grpId: string;
}

interface Args {
  isAdminView: boolean;
  allGroups: Group[] | undefined;
  groupRoles: GroupRole[];
  oid?: string;
}

export const useUserVisibleGroupIds = ({ isAdminView, allGroups, groupRoles, oid }: Args) => {
  return useMemo(() => {
    if (isAdminView) return allGroups?.map((g) => g.grpId);
    const allowed = groupRoles.filter((each) => {
      if (each.role === 'admin') return false;
      if (each.role === 'mentee' && oid === AGILE_ORG) return false;
      return true;
    });
    return allowed.map((each) => each.id);
  }, [isAdminView, allGroups, groupRoles, oid]);
};
